import "../../App.scss";
import React, { useEffect, useState } from "react";
import Banner from "./main-banner/Banner.js";
import Process from "./Process/Process.js";
import Crypto from "./CryptoPrices/Crypto.js";
import Discover from "./Discover/Discover.js";
import Trade from "./Trade/Trade.js";
import Staking from "./Staking/Staking.js";
import News from "./News/News.js";
import Visionary from "./Visionary/Visionary.js";
import Selfserve from "./SelfServe/Selfserve.js";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.js";
// import IntercomComponent from "../Intercom/Intercom.js";
import { useTranslation } from "react-i18next";

function Landing() {
  const { t } = useTranslation();

  // const [showModal, setShowModal] = useState(false);

  // useEffect(() => {
  //   const hasVisited = localStorage.getItem("hasVisitedLimitedTimeModal");

  //   if (!hasVisited) {
  //     setShowModal(true);
  //     localStorage.setItem("hasVisitedLimitedTimeModal", "true");
  //   }
  // }, []);

  // const handleClose = () => setShowModal(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Banner />
      {/* <Crypto /> */}
      <Discover />
      <Process />
      {/* <Trade /> */}
      {/* <Staking /> */}
      {/* <Selfserve /> */}
      <Visionary />
      {/* <News /> */}

      {/* <IntercomComponent /> */}
      {/* <Modal
        className="common-modal-style stakingmodal premiumstake-modal limitedtimeoffer-modal"
        show={showModal}
        onHide={handleClose}
        centered
        style={{ zIndex: "9999999999999999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('pre13')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-4">
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\staking\limitedtimeofferbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\staking\premiumsvg.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                {t('savetext')}
              </h5>
              <p>
                {t('unlocktext')}
              </p>
            </div>
            <div className="d-flex justify-content-center mb-4">
            </div>
            <div className="stakingbtns" style={{ maxWidth: "95%", margin: "0 auto" }}>
              <Link to="/premium" className="w-100">
                <button
                  className="confirmbtn"
                >
                  {t('pre15')}
                </button></Link>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default Landing;
